import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrInsightsDetailsSocialItemInCls: string;
			communityPlsrInsightsDetailsSocialItemXCls: string;
			communityPlsrInsightsDetailsNewsDateCls: string;
			communityPlsrInsightsDetailsNewsCategoryCls: string;
			communityPlsrInsightsDetailsContentContentSectionHeaderCls: string;
			communityPlsrInsightsDetailsNewsImgCls: string;
			communityPlsrInsightsDetailsNewsContentCls: string;
			communityPlsrInsightsDetailsNewsMediaCls: string;
			communityPlsrInsightsDetailsNewsDisclaimerCls: string;
			communityPlsrInsightsDetailsNewsPersonCls: string;
		}
	},

	slug: string
}

class Content extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Insights Details Content Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsSocialItemInCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsSocialItemXCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsDateCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsCategoryCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsContentContentSectionHeaderCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsImgCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsContentCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsDisclaimerCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsPersonCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});

		if(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsMediaCls) {
			const mediaElementHtml = document.querySelector(this.publicVars.cssId.anim.communityPlsrInsightsDetailsNewsMediaCls);

			if(mediaElementHtml) {
				scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsNewsMediaCls || '', 'community_plsr_insights_details_content', { animCls: 'animate__fadeIn', once: true});
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default Content;